import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const apiUrlPlatos = process.env.REACT_APP_API_PLATOS;

function AbmPlatos() {
  const navigate = useNavigate();
  const [platos, setPlatos] = useState([]);
  const [searchTerms, setSearchTerms] = useState({});
  const [platoAEliminar, setPlatoAEliminar] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedTipo, setExpandedTipo] = useState(null);

  useEffect(() => {
    getPlatos();
  }, []);

  const getPlatos = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(apiUrlPlatos);
      setPlatos(res.data);
    } catch (error) {
      console.error("Error al cargar platos:", error);
      alert('❌ Error al cargar los platos');
    } finally {
      setIsLoading(false);
    }
  };

  const deletePlato = async () => {
    try {
      await axios.delete(`${apiUrlPlatos}${platoAEliminar.id_plato}`);
      alert('✅ Plato eliminado correctamente');
      setShowModal(false);
      setPlatoAEliminar(null);
      getPlatos();
    } catch (error) {
      console.error("Error al eliminar el plato:", error);
      alert('❌ Error al eliminar: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleSearchChange = (e, tipo) => {
    const updatedSearchTerms = { ...searchTerms, [tipo]: e.target.value };
    setSearchTerms(updatedSearchTerms);
  };

  const tiposUnicos = [...new Set(platos.map((plato) => plato.tipoplato?.nombre || 'Sin clasificar'))];

  const getTipoColor = (tipo) => {
    const colores = {
      'General': 'from-amber-500 to-orange-600',
      'Veggie': 'from-green-500 to-emerald-600',
      'Pechuga': 'from-yellow-500 to-amber-600',
      'Dieta': 'from-teal-500 to-cyan-600',
      'Celiaco': 'from-purple-500 to-pink-600',
      'Diabético': 'from-red-500 to-rose-600',
      'Sin clasificar': 'from-gray-500 to-slate-600'
    };
    return colores[tipo] || 'from-blue-500 to-indigo-600';
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-2xl shadow-xl">
          <div className="flex items-center gap-4">
            <svg className="animate-spin h-8 w-8 text-orange-600" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span className="text-lg font-semibold text-gray-700">Cargando platos...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-100 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-orange-500">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-gradient-to-br from-orange-500 to-amber-600 p-4 rounded-xl shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Gestión de Platos</h1>
                <p className="text-gray-600 mt-1">Administra el menú y los platos disponibles</p>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => navigate("/admin/tipos-plato")}
                className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-blue-600 hover:to-indigo-700 transform hover:scale-105 transition-all flex items-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Gestionar Tipos
              </button>
              <button
                onClick={() => navigate("/admin/CreatePlatos")}
                className="bg-gradient-to-r from-orange-600 to-amber-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-orange-700 hover:to-amber-700 transform hover:scale-105 transition-all flex items-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Crear Plato
              </button>
            </div>
          </div>
        </div>

        {/* Layout de dos columnas */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex" style={{ height: 'calc(100vh - 250px)' }}>
          {/* Sidebar izquierda - Tipos de plato */}
          <div className="w-80 border-r border-gray-200 overflow-y-auto bg-gray-50">
            <div className="p-4 bg-gradient-to-r from-orange-500 to-amber-600 text-white font-bold">
              Tipos de Plato
            </div>
            <div className="p-2">
              {tiposUnicos.map((tipo) => {
                const cantidadPlatos = platos.filter((plato) => (plato.tipoplato?.nombre || 'Sin clasificar') === tipo).length;
                const isSelected = expandedTipo === tipo;

                return (
                  <button
                    key={tipo}
                    onClick={() => setExpandedTipo(tipo)}
                    className={`w-full text-left p-4 mb-2 rounded-lg transition-all ${isSelected
                        ? `bg-gradient-to-r ${getTipoColor(tipo)} text-white shadow-lg transform scale-105`
                        : 'bg-white hover:bg-gray-100 text-gray-700 border border-gray-200'
                      }`}
                  >
                    <div className="flex items-center justify-between">
                      <span className="font-semibold">{tipo}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${isSelected
                          ? 'bg-white bg-opacity-20 text-white'
                          : 'bg-orange-100 text-orange-800'
                        }`}>
                        {cantidadPlatos}
                      </span>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Contenido derecho - Platos del tipo seleccionado */}
          <div className="flex-1 flex flex-col overflow-hidden">
            {expandedTipo ? (
              <>
                {/* Header del tipo seleccionado */}
                <div className={`bg-gradient-to-r ${getTipoColor(expandedTipo)} p-6 text-white`}>
                  <h2 className="text-2xl font-bold mb-2">{expandedTipo}</h2>
                  <p className="text-white text-opacity-90">
                    {platos.filter((plato) => (plato.tipoplato?.nombre || 'Sin clasificar') === expandedTipo).length} platos disponibles
                  </p>
                </div>

                {/* Buscador */}
                <div className="p-6 bg-gray-50 border-b border-gray-200">
                  <input
                    type="text"
                    placeholder={`Buscar en ${expandedTipo}...`}
                    value={searchTerms[expandedTipo] || ''}
                    onChange={(e) => handleSearchChange(e, expandedTipo)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none shadow-sm"
                  />
                </div>

                {/* Tabla de platos */}
                <div className="flex-1 overflow-y-auto p-6">
                  <table className="w-full">
                    <thead className="bg-gray-100 sticky top-0 z-10">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-bold text-gray-700 uppercase">Nombre</th>
                        <th className="px-4 py-3 text-left text-sm font-bold text-gray-700 uppercase">Descripción</th>
                        <th className="px-4 py-3 text-center text-sm font-bold text-gray-700 uppercase w-32">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {platos
                        .filter((plato) => (plato.tipoplato?.nombre || 'Sin clasificar') === expandedTipo)
                        .filter((plato) => {
                          const searchTerm = searchTerms[expandedTipo]?.toLowerCase() || "";
                          return searchTerm === "" || plato.nombre.toLowerCase().includes(searchTerm);
                        })
                        .map((plato) => (
                          <tr key={plato.id_plato} className="hover:bg-orange-50 transition-colors">
                            <td className="px-4 py-4 font-medium text-gray-900">{plato.nombre}</td>
                            <td className="px-4 py-4 text-gray-700">{plato.descripcion}</td>
                            <td className="px-4 py-4">
                              <div className="flex justify-center gap-2">
                                <button
                                  onClick={() => navigate(`/admin/EditarPlatos/${plato.id_plato}`)}
                                  className="bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 transition-colors shadow-md"
                                  title="Editar"
                                >
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => {
                                    setPlatoAEliminar(plato);
                                    setShowModal(true);
                                  }}
                                  className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition-colors shadow-md"
                                  title="Eliminar"
                                >
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <div className="flex-1 flex items-center justify-center text-gray-400">
                <div className="text-center">
                  <svg className="w-24 h-24 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  <p className="text-xl font-semibold">Selecciona un tipo de plato</p>
                  <p className="text-sm mt-2">Elige una categoría del menú lateral para ver los platos</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal de confirmación */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full mx-4">
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-red-100 p-3 rounded-full">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Confirmar eliminación</h3>
                <p className="text-gray-600 mt-1">Esta acción no se puede deshacer</p>
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              ¿Estás seguro de que deseas eliminar el plato <strong>{platoAEliminar?.nombre}</strong>?
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowModal(false);
                  setPlatoAEliminar(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-medium transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={deletePlato}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition-colors"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AbmPlatos;

